export default __webpack_public_path__ + "9f3602c2fede49b8361bf7e1d25df0fa.svg";